/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "01",
    code: "1",
    asset: "1. Doanh thu bán hàng và cung cấp dịch vụ",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 1,
    stt: "02",
    code: "1",
    asset: "3. Các khoản giảm trừ doanh thu",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "10",
    code: "1",
    asset: "3. Doanh thu thuần về bán hàng và cung cấp dịch vụ (10=01-02)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "11",
    code: "1",
    asset: "4. Giá vốn hàng bán",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "20",
    code: "1",
    asset: "5. Lợi nhuận gộp về bán hàng và cung cấp dịch vụ (20=10-11)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "21",
    code: "1",
    asset: "6. Doanh thu hoạt động tài chính",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "22",
    code: "1",
    asset: "7. Chi phí tài chính",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "23",
    code: "1",
    asset: "- Trong đó: Chi phí lãi vay",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "24",
    code: "1",
    asset: "8. Chi phí quản lý kinh doanh",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "30",
    code: "1",
    asset: "9. Lợi nhuận thuần từ hoạt động kinh doanh (30=20+21-22-24)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "31",
    code: "1",
    asset: "10. Thu nhập khác",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "32",
    code: "1",
    asset: "11. Chi phí khác",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "40",
    code: "1",
    asset: "12. Lợi nhuận khác",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "41",
    code: "1",
    asset: "13. Doanh thu hoạt động tín dụng nội bộ",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "42",
    code: "1",
    asset: "14. Chi phí hoạt động tín dụng nội bộ",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "45",
    code: "1",
    asset: "15. Lợi nhuận từ hoạt động tín dụng nội bộ (45=41-42)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "50",
    code: "1",
    asset: "16. Tổng lợi nhuận kế toán trước thuế (50=30+40+45)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "51",
    code: "1",
    asset: "17. Chi phí thuế TNDN",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "60",
    code: "1",
    asset: "18. Lợi nhuận sau thuế thu nhập doanh nghiệp (60=50-51)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
];

export default function Table2({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã số</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Năm nay</Th>
              <Th style={{ textAlign: "center" }}>Năm trước</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>1</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>2</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>3</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>4</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>5</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  {rows.valueCenter && rows.valueCenter === true ? (
                    <>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.now}
                      </Td>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.before}
                      </Td>
                    </>
                  ) : (
                    <>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="now"
                          readOnly={rows.readOnly}
                          value={rows.value.now}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="before"
                          readOnly={rows.readOnly}
                          value={rows.value.before}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
